import React from "react";
import ChargeBackAndDisputeOverview from "./ChargeBackAndDisputeOverview";
import FraudManagmentOverview from "./FraudManagmentOverview";
import ProgramManagementServicesOverview from "./ProgramManagementServicesOverview";
import MobileTextMessagesServiceOverview from "./MobileTextMessagesServiceOverview";
import AutomatedClearingHouse from "./AutomatedClearingHouse";
import ValueAddedServicesOverview from "./ValueAddedServicesOverview";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";

const OptionalFeatures = ({ data }) => {
  if (!data) return <DataNotFound />;

  return (
    <React.Fragment>
      <FraudManagmentOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <ChargeBackAndDisputeOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <ProgramManagementServicesOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <AutomatedClearingHouse data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <MobileTextMessagesServiceOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <ValueAddedServicesOverview data={data} />
    </React.Fragment>
  );
};
export default OptionalFeatures;
